export const TextButton = (props) => {
  const { label, onClick, disabled } = props || {};
  return (
    <button
      disabled={disabled}
      onClick={onClick}
      className={`text-primary font-semibold text-base ${disabled && 'cursor-progress'}`}
    >
      {label}
    </button>
  );
};
